import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const textConditionList = [
  'Begin with',
  'Contains',
  'Doesn\'t contain',
  'Ends with',
  'Equals',
  'Doesn\'t equal',
];

let typingTimer;
const doneTypingInterval = 1000;
const ctrlKeyMap = { 17: false, 86: false };
const shiftKeyMap = { 91: false, 86: false };

const StringFilterHeaderCell = (props) => {
  const [data, setData] = useState(props.value);
  const [conditionIndex, setConditionIndex] = useState(props.conditionIndex);

  const wrapperRef = useRef(null);
  const input = useRef(null);

  const doneTyping = () => {
    const { setFilter } = props;
    setData(input.current.value);
    setFilter({ data: input.current.value, conditionIndex });
  };

  const onKeyUpHandler = (e) => {
    switch (props.type) {
      case 'text':
        if (/[a-zA-Z ]/i.test(e.key)) {
          clearTimeout(typingTimer);
          typingTimer = setTimeout(doneTyping, doneTypingInterval);
        }
        break;
      case 'number':
        if (e.keyCode in ctrlKeyMap) {
          ctrlKeyMap[e.keyCode] = true;
        }
        if (e.keyCode in shiftKeyMap) {
          shiftKeyMap[e.keyCode] = true;
        }
        if (/[0-9. ]/i.test(e.key) || e.key === 'Backspace' || e.key === 'Delete' || (ctrlKeyMap[17] && ctrlKeyMap[86]) || (shiftKeyMap[91] && shiftKeyMap[86])) {
          clearTimeout(typingTimer);
          typingTimer = setTimeout(doneTyping, doneTypingInterval);
        }
        break;
      default:
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    }
  };

  const onKeyDownHandler = (e) => {
    switch (props.type) {
      case 'text':
        if (/[a-zA-Z ]/i.test(e.key)) {
          clearTimeout(typingTimer);
        }
        break;
      case 'number':
        if (e.keyCode in shiftKeyMap) {
          shiftKeyMap[e.keyCode] = false;
        }
        if (e.keyCode in ctrlKeyMap) {
          ctrlKeyMap[e.keyCode] = false;
        }
        if (/[0-9. ]/i.test(e.key) || e.key === 'Backspace' || e.key === 'Delete') {
          clearTimeout(typingTimer);
        }
        break;
      default:
        clearTimeout(typingTimer);
    }
  };

  const onChangeHander = (e) => {
    e.preventDefault();
    switch (props.type) {
      case 'text':
        setData(input.current.value.replace(/[^a-zA-Z ]/g, ''));
        break;
      case 'number':
        setData(input.current.value.replace(/[^0-9. ]/g, ''));
        break;
      default:
        setData(input.current.value);
        break;
    }
  };

  const handleCondition = (index) => {
    const { setFilter } = props;
    setConditionIndex(index);
    setFilter({ data, conditionIndex: index });
  };

  return (
    <th className="header-cell">
      <div className="header-cell-container has-filter" ref={wrapperRef}>
        <input
          type="text"
          className="form-control"
          placeholder=""
          value={data}
          ref={input}
          onChange={e => onChangeHander(e)}
          onKeyUp={e => onKeyUpHandler(e)}
          onKeyDown={e => onKeyDownHandler(e)}
        />
        <ul className={classNames('dropdown-menu', 'first')} role="menu">
          {
            textConditionList.map((item, index) => (
              <li key={`fromfilter-condition-${index.toString()}`}>
                <a href={window.location.href} onClick={() => handleCondition(index)} className={classNames({ 'active-dropdown': index === conditionIndex })}>{item}</a>
              </li>
            ))
          }
        </ul>
      </div>
    </th>
  );
};

StringFilterHeaderCell.propTypes = {
  setFilter: PropTypes.func,
  value: PropTypes.string,
  conditionIndex: PropTypes.number,
  type: PropTypes.string,
};

StringFilterHeaderCell.defaultProps = {
  setFilter: () => {},
  value: '',
  conditionIndex: 1,
  type: '',
};

export default StringFilterHeaderCell;



// WEBPACK FOOTER //
// ./src/components/Tables/StringFilterHeaderCell.js